var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6575 0.515653C15.2004 0.0585846 14.5148 0.0585846 14.0578 0.515653L5.48774 9.08568L1.94547 5.5434C1.4884 5.08633 0.802798 5.08633 0.345731 5.5434C-0.111337 6.00047 -0.111337 6.68607 0.345731 7.14314L4.68788 11.4853C4.91641 11.7138 5.14494 11.8281 5.48774 11.8281C5.83054 11.8281 6.05908 11.7138 6.28761 11.4853L15.6575 2.11539C16.1146 1.65832 16.1146 0.97272 15.6575 0.515653Z",
    fill: "#0A6365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepComplete);
export default __webpack_public_path__ + "static/media/step-complete.ae268ad7a961ec55a45f8b971457e448.svg";
export { ForwardRef as ReactComponent };